module.exports = __webpack_public_path__ + "static/media/mysql.f80a91ba.svg";